var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
export class SearchTemplateModel {
    authorId;
    cdate;
    comment;
    communityId;
    countryId;
    date;
    dateEnd;
    dateFormat;
    depositoryId;
    description;
    details;
    fileName;
    id;
    locationId;
    name;
    physicalFormId;
    stockageId;
    stockageReferenceId;
    suggest;
    userId;
}
__decorate([
    Expose({ name: 'author_id' }),
    __metadata("design:type", String)
], SearchTemplateModel.prototype, "authorId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], SearchTemplateModel.prototype, "cdate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], SearchTemplateModel.prototype, "comment", void 0);
__decorate([
    Expose({ name: 'community_id' }),
    __metadata("design:type", String)
], SearchTemplateModel.prototype, "communityId", void 0);
__decorate([
    Expose({ name: 'country_id' }),
    __metadata("design:type", Object)
], SearchTemplateModel.prototype, "countryId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], SearchTemplateModel.prototype, "date", void 0);
__decorate([
    Expose({ name: 'date_end' }),
    __metadata("design:type", Object)
], SearchTemplateModel.prototype, "dateEnd", void 0);
__decorate([
    Expose({ name: 'date_format' }),
    __metadata("design:type", Object)
], SearchTemplateModel.prototype, "dateFormat", void 0);
__decorate([
    Expose({ name: 'depository_id' }),
    __metadata("design:type", Object)
], SearchTemplateModel.prototype, "depositoryId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], SearchTemplateModel.prototype, "description", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], SearchTemplateModel.prototype, "details", void 0);
__decorate([
    Expose({ name: 'filename' }),
    __metadata("design:type", Object)
], SearchTemplateModel.prototype, "fileName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], SearchTemplateModel.prototype, "id", void 0);
__decorate([
    Expose({ name: 'location_id' }),
    __metadata("design:type", String)
], SearchTemplateModel.prototype, "locationId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], SearchTemplateModel.prototype, "name", void 0);
__decorate([
    Expose({ name: 'physical_form_id' }),
    __metadata("design:type", Object)
], SearchTemplateModel.prototype, "physicalFormId", void 0);
__decorate([
    Expose({ name: 'stockage_id' }),
    __metadata("design:type", Object)
], SearchTemplateModel.prototype, "stockageId", void 0);
__decorate([
    Expose({ name: 'stockage_reference_id' }),
    __metadata("design:type", Object)
], SearchTemplateModel.prototype, "stockageReferenceId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], SearchTemplateModel.prototype, "suggest", void 0);
__decorate([
    Expose({ name: 'user_id' }),
    __metadata("design:type", String)
], SearchTemplateModel.prototype, "userId", void 0);
